import { DotPulse } from "components/common/Animation/DotPulse/DotPulse";
import { LinearProgress } from "components/common/LinearProgress/LinearProgress";
import { capitalize } from "client/utils/capitalize";
import { CompressImage } from "store/features/compress/types";
import { translateFunc } from "client/utils/translateFunc";
import { Translate } from "components/common/Translate/Translate";

interface UpdateProps {
    image: CompressImage;
    index: number;
    handleDownload: (image: CompressImage) => void;
}

export const Updates = ({ image, handleDownload, index }: UpdateProps) => {
    return (
        <div className="bg-white dark:bg-darkSurface-200 w-full rounded-xl text-center overflow-hidden">
            {image.error ? (
                <div></div>
            ) : (
                <>
                    {image.state === "downloading" && image.downloading && (
                        <LinearProgress
                            text={
                                image.downloading.progress === "continuous" ? (
                                    capitalize(translateFunc("downloading"))
                                ) : (
                                    <Translate
                                        keyName="percentage-size-progress-label"
                                        variables={{
                                            progress: image.downloading.progress,
                                            size: image.original.size,
                                        }}
                                    />
                                )
                            }
                            testId={`preview-image-${index}-updates-downloading`}
                            percentage={image.downloading.progress === "continuous" ? 0 : image.downloading.progress}
                        />
                    )}
                    {image.state === "uploading" && image.uploading && (
                        <LinearProgress
                            text={
                                image.uploading.progress === "continuous" ? (
                                    capitalize(translateFunc("uploading"))
                                ) : (
                                    <Translate
                                        keyName="download-progress-label"
                                        variables={{
                                            progress: image.uploading.progress,
                                            size: image.original.size,
                                        }}
                                    />
                                )
                            }
                            testId={`preview-image-${index}-updates-importing`}
                            percentage={image.uploading.progress === "continuous" ? 0 : image.uploading.progress}
                        />
                    )}
                    {image.state === "compressed" && image.compressed && (
                        <div className="">
                            <LinearProgress
                                text={capitalize(translateFunc("download"))}
                                percentage={0}
                                isBoldOnHover={true}
                                handleClick={() => handleDownload(image)}
                                testId={`preview-image-${index}-updates-compressed`}
                            />
                        </div>
                    )}
                    {image.state === "added" && (
                        <div className="flex items-center justify-center bg-white dark:bg-darkSurface-200 rounded-md py-2">
                            <DotPulse options={{ color: "var(--dark-blue)" }} />
                        </div>
                    )}
                </>
            )}

            {!image.error && image.state === "compressing" && image.compressing && (
                <div className="flex items-center justify-center bg-white dark:bg-darkSurface-200 rounded-md py-2">
                    <DotPulse options={{ color: "var(--dark-blue)" }} />
                </div>
            )}

            {!image.error &&
                image.state === "importing" &&
                image.importing &&
                (image.importing.progress === "continuous" ? (
                    <div className="flex items-center justify-center bg-white dark:bg-darkSurface-200 rounded-md py-2">
                        <DotPulse options={{ color: "var(--dark-blue)" }} />
                    </div>
                ) : (
                    <div className="bg-white dark:bg-darkSurface-200 w-full rounded-xl text-center overflow-hidden">
                        <LinearProgress
                            text={
                                <Translate
                                    keyName="percentage-size-progress-label"
                                    variables={{
                                        progress: image.importing.progress,
                                        size: image.original.size,
                                    }}
                                />
                            }
                            percentage={image.importing.progress}
                            data-testid={`preview-image-${index}-updates-importing`}
                        />
                    </div>
                ))}
        </div>
    );
};
